export type KeywordItemSchema = {
    isSelected: boolean;
    value: string;
};

export enum AddedKWType {
    TYPING = "typing",
    PASTING = "pasting",
    EXISTING = "from existing",
}
